<template>
    <v-container fluid class="pr-0 pl-0">
        <client-only>
            <v-row column justify-center align-center>
                <v-col v-if="!inviteToken" cols="12">
                    <TranslatableBlockComponent :tstring="{string: 'verifyEmailToResetPassword'}" />
                </v-col>

                <v-col v-else-if="inviteToken" cols="12">
                    <v-card class="mx-auto mt-5" width="500">
                        <v-progress-linear
                            v-if="loader"
                            indeterminate
                            color="#0063a6"
                        ></v-progress-linear>
                        <v-card-title>
                            <h1 class="display-1 mx-auto">{{ title }}</h1>
                        </v-card-title>
                        <v-card-text>
                            <ValidationObserver
                                ref="observer"
                                v-slot="{ handleSubmit }"
                            >
                                <v-form
                                    ref="form"
                                    data-netlify="true"
                                    data-netlify-honeypot="bot-field"
                                    name="accountSetPassword"
                                    action="/set-password/"
                                    method="POST"
                                    @submit.prevent="
                                        handleSubmit(handleSetPassword)
                                    "
                                >
                                    <input
                                        id="form-name"
                                        v-model="loginCreds.formName"
                                        type="hidden"
                                        name="form-name"
                                        value="accountSetPassword"
                                    />
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12">
                                                <ValidationProvider
                                                    name="accountPassword"
                                                    rules="required"
                                                    class="validationWrapper"
                                                    vid="confirmation"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                        >
                                                            {{ errors[0] }}
                                                        </span>
                                                        <!-- id="accountPassword" -->
                                                        <!-- name="accountPassword" -->
                                                        <v-text-field
                                                            v-model="
                                                                loginCreds.password
                                                            "
                                                            :label="
                                                                localize(
                                                                    'password'
                                                                )
                                                            "
                                                            :type="
                                                                showPassword
                                                                    ? 'text'
                                                                    : 'password'
                                                            "
                                                            :hint="
                                                                hints.password
                                                            "
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                dense
                                                            >
                                                                fa-lock
                                                            </v-icon>
                                                            <template
                                                                v-slot:append
                                                            >
                                                                <span
                                                                    tabindex="-1"
                                                                    style="
                                                                        cursor: pointer;
                                                                    "
                                                                    @click="
                                                                        showPassword = !showPassword
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        v-if="
                                                                            showPassword
                                                                        "
                                                                        dense
                                                                        >fa-eye</v-icon
                                                                    >
                                                                    <v-icon
                                                                        v-else
                                                                        dense
                                                                        >fa-eye-slash</v-icon
                                                                    >
                                                                </span>
                                                            </template>
                                                        </v-text-field>
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12">
                                                <ValidationProvider
                                                    name="accountPassword"
                                                    rules="required|confirmed:confirmation"
                                                    class="validationWrapper"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                        >
                                                            {{ errors[0] }}
                                                        </span>
                                                        <!-- id="accountPassword" -->
                                                        <!-- name="accountPassword" -->
                                                        <v-text-field
                                                            v-model="
                                                                loginCreds.confirmation
                                                            "
                                                            :label="
                                                                localize(
                                                                    'confirmPassword'
                                                                )
                                                            "
                                                            :type="
                                                                showConfirmationPassword
                                                                    ? 'text'
                                                                    : 'password'
                                                            "
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                dense
                                                            >
                                                                fa-lock
                                                            </v-icon>
                                                            <template
                                                                v-slot:append
                                                            >
                                                                <span
                                                                    tabindex="-1"
                                                                    style="
                                                                        cursor: pointer;
                                                                    "
                                                                    @click="
                                                                        showConfirmationPassword = !showConfirmationPassword
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        v-if="
                                                                            showConfirmationPassword
                                                                        "
                                                                        dense
                                                                        >fa-eye</v-icon
                                                                    >
                                                                    <v-icon
                                                                        v-else
                                                                        dense
                                                                        >fa-eye-slash</v-icon
                                                                    >
                                                                </span>
                                                            </template>
                                                        </v-text-field>
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-btn
                                                    type="submit"
                                                    color="primary"
                                                    :disabled="loader"
                                                    ><TranslatableStringComponent :tstring="{string: 'setPasswordLogin'}" /></v-btn
                                                >
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-form>
                            </ValidationObserver>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </client-only>
    </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import handleSnackbar from '~/mixins/handleSnackbar'
import handleAuth from '~/mixins/handleAuth'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'

export default {
    name: 'FormSetPassword',
    components: {
        ValidationProvider,
        ValidationObserver,
        TranslatableStringComponent,
        TranslatableBlockComponent,
    },
    mixins: [handleSnackbar, handleAuth],
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showPassword: false,
            showConfirmationPassword: false,
            displayError: '',
            loginCreds: {
                password: null,
                formName: 'accountSetPassword',
            },
            hints: {
                password: this.localize('pleaseSetAStrongPassword'),
            },
            loader: false,
        }
    },
    computed: {},
    methods: {
        ...mapActions('auth', ['attemptAcceptInvitaion']),
        async handleSetPassword() {
            this.loader = true
            const token = this.inviteToken
            await this.attemptAcceptInvitaion({ token, ...this.loginCreds })
                .then(() => {
                    this.loader = false
                    this.hitSnackbar(
                        { string: 'successfulLoginMessage' },
                        ''
                    )
                    this.routerPush({
                        type: 'account',
                        slugName: 'dashboard',
                    })
                })
                .catch((err) => {
                    this.loader = false
                    const errorMessage = err.json.msg
                    this.hitSnackbar(errorMessage, {})
                    console.log(err, 'womp womp. Something went wrong.')
                })
        },
    },
}
</script>
